import {
  Button, Col, Flex, Row
} from "antd";
import { lazy, Suspense } from "react";
import Layout from "../components/layout";
import HeroScreen from "../components/HeroScreen/heroScreen";
import classes from "../components/HeroScreen/heroScreen.module.css";
import { useNav } from "../hooks/useNav";
import Container from "../components/container";

const AboutScreen = lazy(() => import("../components/Screens/about"));
const AdvantagesScreen = lazy(() => import("../components/Screens/advantages"));

const AboutUs = () => {
  const { navExperts } = useNav();

  return (
    <Layout>
      <HeroScreen imgSrc="/landing/about/hero.png">
        <h1 className="heroTitle">Il progetto</h1>
        <Flex
          vertical
          gap={16}
          className={classes.text}
        >
          <p>
            Siamo un team di professionisti che fornisce
            servizi di psiconcologia ai pazienti affetti da cancro,
            ai caregiver e al personale sanitario.
            Vogliamo offrire un supporto concreto e personalizzato a chi affronta la malattia,
            attraverso un percorso di cura psicologica mirato.
          </p>
        </Flex>
        <Button onClick={() => navExperts()} size="large">Trova il tuo psiconcologo</Button>
      </HeroScreen>
      <Suspense>
        <AboutScreen
          title="I nostri psiconcologi"
          button={(
            <Button type="dashed" size="large" onClick={() => navExperts()}>
              Trova il tuo psiconcologo
            </Button>
        )}
        />
      </Suspense>
      <div className="py-[3rem]">
        <Container>
          <Row gutter={[24, 48]}>
            <Col span={24} lg={12}>
              <Flex justify="center" align="start" className="h-full" vertical>
                <h2 className="heading mb-[8px]">
                  Il nostro impegno
                </h2>
                <p className="text-base">
                  Il nostro impegno è fornire un servizio di alta qualità.
                  Supportiamo emotivamente e psicologicamente chi affronta la malattia,
                  con un approccio mirato e professionale,
                  focalizzato al miglioramento del benessere mentale
                  durante ogni fase del percorso oncologico.
                </p>
                <Button type="primary" size="large" onClick={() => navExperts()}>
                  Trova il tuo psiconcologo
                </Button>
              </Flex>
            </Col>
            <Col span={24} lg={12}>
              <img src="/landing/about/img-1.png" alt="img" className="w-full"/>
            </Col>
            <Col span={24} lg={12}>
              <img src="/landing/about/img-2.png" alt="img" className="w-full" />
            </Col>
            <Col span={24} lg={12}>
              <Flex justify="center" align="start" className="h-full" vertical>
                <h2 className="heading mb-[8px]">
                  Il nostro team
                </h2>
                <p className="text-base pb-[20px]">
                  Siamo un team di psiconcologi specializzati,
                  con una vasta esperienza nel supporto psicologico ai pazienti oncologici,
                  ai loro caregiver e al personale sanitario.
                  Offriamo un servizio altamente personalizzato,
                  basato sulle esigenze specifiche di ogni individuo.
                </p>
                <Flex vertical gap={20} className="text-base">
                  <Flex align="center" gap={12}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 28 28" fill="none">
                      <path d="M8.75065 14.0002L12.2507 17.5002L19.2507 10.5002M25.6673 14.0002C25.6673 20.4435 20.444 25.6668 14.0007 25.6668C7.55733 25.6668 2.33398 20.4435 2.33398 14.0002C2.33398 7.55684 7.55733 2.3335 14.0007 2.3335C20.444 2.3335 25.6673 7.55684 25.6673 14.0002Z" stroke="#204480" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>
                      Supporto psiconcologico personalizzato
                    </span>
                  </Flex>
                  <Flex align="center" gap={12}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 28 28" fill="none">
                      <path d="M8.75065 14.0002L12.2507 17.5002L19.2507 10.5002M25.6673 14.0002C25.6673 20.4435 20.444 25.6668 14.0007 25.6668C7.55733 25.6668 2.33398 20.4435 2.33398 14.0002C2.33398 7.55684 7.55733 2.3335 14.0007 2.3335C20.444 2.3335 25.6673 7.55684 25.6673 14.0002Z" stroke="#204480" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>
                      Accesso 24 ore 7 giorni alla settimana
                    </span>
                  </Flex>
                  <Flex align="center" gap={12}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 28 28" fill="none">
                      <path d="M8.75065 14.0002L12.2507 17.5002L19.2507 10.5002M25.6673 14.0002C25.6673 20.4435 20.444 25.6668 14.0007 25.6668C7.55733 25.6668 2.33398 20.4435 2.33398 14.0002C2.33398 7.55684 7.55733 2.3335 14.0007 2.3335C20.444 2.3335 25.6673 7.55684 25.6673 14.0002Z" stroke="#204480" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>
                      Altissima specializzazione dei nostri professionisti
                    </span>
                  </Flex>
                </Flex>
              </Flex>
            </Col>
            <Col span={24} lg={12}>
              <Flex justify="center" align="start" className="h-full" vertical>
                <h2 className="heading mb-[8px]">
                  La nostra visione
                </h2>
                <p className="text-base">
                  La nostra visione si basa sull&apos;idea che
                  sia essenziale trattare non solo il corpo,
                  ma anche la mente durante il percorso di cura.
                  Riconosciamo l&apos;importanza fondamentale della psiconcologia
                  nel fornire supporto emotivo e psicologico ai pazienti,
                  ai caregiver e al personale sanitario.
                </p>
                <Button type="primary" size="large" onClick={() => navExperts()}>
                  Trova il tuo psiconcologo
                </Button>
              </Flex>
            </Col>
            <Col span={24} lg={12}>
              <img src="/landing/about/img-3.png" alt="img" className="w-full" />
            </Col>
          </Row>
        </Container>
      </div>
      <Suspense>
        <AdvantagesScreen/>
      </Suspense>
    </Layout>
  );
};

export default AboutUs;
